export default __webpack_public_path__ + "static/media/view.2e261984.svg";